import PropTypes from 'prop-types';
import React from 'react';

const GreeceSpecificContent = ({ customers }) => {
  const { Type, Name, AccountNumber } = customers?.[0] || {};

  if (Type !== 'B2B') return null;

  return (
    <>
      <section>
        <article className="justify-between">
          <p>Στοιχεία πελάτη:</p>
        </article>
        <article className="justify-between">
          <p>ΕΠΩΝΥΜΙΑ: {Name?.FullName}</p>
        </article>
        <article className="justify-between">
          <p>ΑΦΜ: {AccountNumber}</p>
        </article>
      </section>
      <br />
    </>
  );
};

GreeceSpecificContent.defaultProps = {
  customers: [],
};

GreeceSpecificContent.propTypes = {
  customers: PropTypes.arrayOf(PropTypes.shape()),
};

export default GreeceSpecificContent;
